<div class="customer-add-successfully">
  <div class="row header-row">
    <div class="col-8 pl-0" style="margin-top: -68px;">
      <div class="check-circle">
        <i class="fas fa-check-circle check-circle-icon" (click)="createEstimate()"></i>
      </div>
    </div>
    <!-- <div class="col-4 flex-end-center pr-0"> <i class="far fa-times pointer dialog-close" (click)="handleClose()"></i> -->
    <!-- </div> -->
    <div class="col-12 status pl-0 mb-2" style="margin-top: -10px">{{createdStatus === 'Vehicle' || createdStatus ===
      'Customer' ?
      createdStatus+' added ' : createdStatus}} successfully!</div>
    <div class="col-12">
      <div class="row customer-info pl-0">
        <div class="col-2 content-end">
          <div class="user-icon-body">
            <i class="far fa-user user-icon"></i>
          </div>
        </div>

        <div class="col-9 pl-0 user-data">
          <div class="heading">
            {{customer?.fullNameQBO || customer?.fullName}}
          </div>
          <div class="sub-heading">
            {{customer?.isFleetCustomer?'Fleet':'Regular'}}
          </div>
        </div>
        <div class="col-1 content-end pr-0">
          <i class="far fa-edit pointer p-2" (click)="editCustomer()"></i>
        </div>

      </div>
      <!-- *ngIf="customerInfo && customerInfo.vehicle" -->
      <div class="row vehicle pl-0"
        *ngIf="createdStatus === 'Vehicle' && customerInfo.vehicle && customerInfo.vehicle.isActive">
        <div class="col-1 l-border">
          <div>L</div>
        </div>
        <div class="col-11 customer-info">
          <div class="row">
            <div class="col-2 content-end">
              <div class="user-icon-body">
                <i class="far fa-car user-icon"></i>
                <!-- <i class="far fa-calendar-alt user-icon" *ngIf="customerInfo && customerInfo.time"></i> -->
              </div>
            </div>
            <div class="col-9 pl-0 user-data">
              <div class="heading">
                <span *ngIf="customerInfo && customerInfo.event === 'vehicle_created'">
                  {{customerInfo?.vehicle?.vehicleName || customerInfo?.vehicle?.name}}
                </span>
                <span *ngIf="customerInfo && customerInfo.time">
                  {{customerInfo?.month}} {{customerInfo?.date}}, {{customerInfo?.year}} {{customerInfo?.time}}
                </span>
              </div>
              <div class="sub-heading">
                <span *ngIf="customerInfo && customerInfo.event === 'vehicle_created'"
                  [innerHTML]="customerInfo?.vehicle?.VIN | highlightVin">
                </span>
                <span *ngIf="customerInfo && customerInfo.time">
                  {{customerInfo?.vehicleName}}
                </span>
              </div>
            </div>
            <div class="col-1 content-end pr-0 edit-icon">
              <i class="far fa-edit pointer p-2" (click)="editVehicleOrAppointment(customerInfo)"></i>
            </div>
          </div>
        </div>
      </div>

      <div class="row vehicle pl-0" *ngIf="appointmentInfo && createdStatus === 'Appointment scheduled'">
        <div class="col-1 l-border">
          <div>L</div>
        </div>
        <div class="col-11 customer-info">
          <div class="row">
            <div class="col-2 content-end">
              <div class="user-icon-body">
                <i class="far fa-calendar-alt user-icon"></i>
              </div>
            </div>
            <div class="col-9 pl-0 user-data">
              <div class="heading">
                <span>
                  {{appointmentInfo?.month}} {{appointmentInfo?.date}}, {{appointmentInfo?.year}}
                  {{appointmentInfo?.time}}
                </span>
              </div>
              <div class="sub-heading">
                <span>
                  {{appointmentInfo?.vehicleName}}
                </span>
              </div>
            </div>
            <div class="col-1 content-end pr-0 edit-icon">
              <i class="far fa-edit pointer p-2" (click)="editVehicleOrAppointment(appointmentInfo)"></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="ui-g border-style content-center" style="padding-bottom:20px;">
    <div class="col-12 pt-3 pb-3 start-text">You can also do the following:</div>
    <div class="box pointer" (click)="showAddVehicle()">
      <div class="icon">

        <i class="fal fa-cars"></i>
      </div>
      <div class="heading vehicle-special-case">
        Add
        Vehicles
      </div>
    </div>
    <div class="box pointer" (click)="createEstimate()">
      <div class="icon">

        <i class="fal fa-file-alt"></i>
      </div>
      <div class="heading">
        Create Estimate
      </div>
    </div>
    <div class="box pointer" (click)="showAddAppointments()" *ngIf="!appointmentInfo">
      <div class="icon">

        <i class="fal fa-calendar-alt"></i>
      </div>
      <div class="heading">
        Schedule Appointment
      </div>
    </div>
    <div class="box pointer" (click)="addFollowUpCustomer()" *ngIf="isMarketingEnabled">
      <div class="icon">
        <i class="fal fa-alarm-clock"></i>
      </div>
      <div class="heading">
        Add <br> followup
      </div>
    </div>

    <div class="disabled-box" *ngIf="!isMarketingEnabled" tooltipPosition="bottom"
      [pTooltip]="'Customer is not eligible for any follow ups'">
      <div class="icon">
        <i class="fal fa-alarm-clock"></i>
      </div>
      <div class="heading">
        Add <br> followup
      </div>
    </div>
  </div>
</div>
